/*
 * @Author: lishiqiao
 * @Date: 2022-03-07 17:25:28
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-10-24 15:56:36
 */
import http from "@/axios/index";
import Page from "@/utils/methods/page"

export default {
    /**
     * @Author: lishiqiao
     * @Date: 2022-03-08 09:34:07
     * @description: 区域条件
     * @param {*} params
     */
    getGroupList(params) {
        const url = `/outHarvestDailyGroup/getGroupConditions`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-08 09:35:17
     * @description: 品种条件
     * @param {*} params
     */
    getBreedList(params) {
        const url = `/outHarvestDailyGroup/getBreedConditions`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-08 09:36:57
     * @description: 造次条件
     * @param {*} params
     */
    getPeriodList(params) {
        const url = `/outHarvestDailyGroup/getPeriodConditions`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-08 09:37:53
     * @description: 品类条件
     * @param {*} params
     */
    getBreedTypeList(params) {
        const url = `/outHarvestDailyGroup/getTypeConditions`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-08 11:02:07
     * @description: 塘口收获-区域下拉
     * @param {*} params
     */
    getPondGroupList(params) {
        const url = `/mdtPondHarvest/queryBoxGroup`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-08 11:02:07
     * @description: 塘口收获-区域下拉
     * @param {*} params
     */
    getPondGroupListNew(params) {
        const url = `/mdtPondHarvestGroup/getGroupConditions`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-08 11:03:07
     * @description: 塘口收获-批次下拉
     * @param {*} params
     */
    getPondBatchList(params) {
        const url = `/desktopReport/queryBoxBatch`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-08 11:04:53
     * @description: 塘口收获-品类下拉
     * @param {*} params
     */
    getPondBreedTypeList(params) {
        const url = `/desktopReport/queryBoxType`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-08 11:05:56
     * @description: 塘口收获-品种下拉
     * @param {*} params
     */
    getPondBreedList(params) {
        const url = `/desktopReport/queryBoxBreed`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-08 11:07:05
     * @description: 塘口收获-养殖场下拉
     * @param {*} params
     */
    getPondBaseList(params) {
        const url = `/mdtPondHarvestGroup/getBaseConditions`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-08 11:08:00
     * @description: 塘口收获-造次下拉
     * @param {*} params
     */
    getPondPeriodList(params) {
        const url = `/mdtPondHarvestGroup/getPeriodConditions`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-08 09:58:26
     * @description: 收获概览-产量报表-分页
     * @param {*} params
     */
    getOutPutPageList(params) {
        const url = `/outHarvestDailyGroup/searchOutHarvestDailyGroupList`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-08 10:02:12
     * @description: 收获概览-产量报表分页-（养成、育苗）分页导出
     * @param {*} params
     */
    exportOutPutData(params) {
        const url = `/outHarvestDailyGroup/exportOutHarvestDailyGroupList`;
        return Page.exportDatas(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-08 10:03:01
     * @description: 收获概览-塘口收获情况-（养成、育苗）分页
     * @param {*} params
     */
    getPondPageList(params) {
        // const url = `/mdtPondHarvest/searchMdtPondHarvestList`;
        const url = `/mdtPondHarvestGroup/searchMdtPondHarvestGroupList`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-08 10:03:39
     * @description: 收获概览-塘口收获情况-（养成、育苗）分页导出
     * @param {*} params
     */
    exportPondData(params) {
        // const url = `/mdtPondHarvest/exportMdtPondHarvestList`;
        const url = `/mdtPondHarvestGroup/exportMdtPondHarvestGroupList`;
        return Page.exportDatas(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-09 11:50:31
     * @description: 根据角色权限获取养殖场下拉列表
     * @param {*}
     */
    getBaseListsByUser() {
        const url = '/baseData/queryBaseDataListByRole';
        return http.get(url);
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-09 13:36:50
     * @description: 获取基地下的除总仓下的区域
     * @param {*} baseId
     */
    queryBaseGroupList(baseId) {
        const url = '/baseGroup/queryBaseGroupList';
        return http.post(url, {
            baseId: baseId,
            groupFlag: 0,
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-09 13:38:22
     * @description: 获取区域塘口接口
     * @param {*} groupId
     */
    listDataPermissionBoxData(groupId) {
        const url = '/boxData/listDataPermissionBoxData/' + groupId;
        return http.get(url);
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-09 13:45:11
     * @description: 获取养殖品种下拉列表
     * @param {*} orgId
     */
    getDetailBreedList(orgId) {
        const url = '/breedData/getListMap/orgId/' + orgId;
        return http.get(url);
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-09 14:37:12
     * @description: 根据机构id获取一级机构信息
     * @param {*} orgId
     */
    getOrgInfoByOrgId(orgId) {
        const url = '/org/getParentOrg/' + orgId;
        return http.get(url);
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-09 13:46:23
     * @description: 根据机构id获取客户列表
     * @param {*} orgId
     */
    getCustomerList(orgId) {
        const url = '/customerData/getCustomerOrgList/' + orgId;
        return http.get(url);
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-09 13:44:10
     * @description: 出鱼操作类型下拉
     * @param {*}
     */
    getOperationTypeList() {
        const url = '/outFishManage/getOperation';
        return http.get(url);
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-09 13:48:27
     * @description: 获取汇总类型
     * @param {*}
     */
    getTotalTypeList() {
        const url = '/outFishManage/getEggGroupByTypeList';
        return http.get(url);
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-08 17:12:31
     * @description: 收获记录分页
     * @param {*} params
     */
    getRecodePageList(params) {
        const url = `/outFishManage/getOutEggList`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-08 17:14:28
     * @description: 导出收获记录
     * @param {*} params
     */
    exportRecodeData(params) {
        const url = `/outFishManage/exportOutEggListExcel`;
        return Page.exportDatas(url, params)
    },
}